<template>
  <div justify="center">
    <v-btn
      color="#033666"
      class="white--text rounded-lg"
      @click.stop="dialog = true"
      :disabled="!SPermission.survey.create"
      dark
      ><v-icon class="mr-2">control_point</v-icon>เพิ่ม Survey</v-btn
    >
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="pa-0 pt-4 pl-5">
            <span>เพิ่ม Survey</span>
          </v-card-title>
          <v-card-title class="pa-0 pt-2 pl-5 pb-4">
            <img src="../../assets/img/linemd.png" width="60px" />
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" sm="4">
                  <v-subheader>ชื่อ Survey :</v-subheader>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-text-field
                    color="#0D8EEE"
                    outlined
                    dense
                    v-model="surveyform.surveyName"
                    :rules="[$store.getters.TextRule(surveyform.surveyName)]"
                    counter="100"
                    maxLength="100"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-subheader>รายละเอียด :</v-subheader>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-text-field
                    color="#0D8EEE"
                    outlined
                    dense
                    v-model="surveyform.surveyDetail"
                    counter="100"
                    maxLength="100"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-subheader>รูปปก Survey :</v-subheader>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-card v-show="!surveyform.surveyCoverPic" flat>
                    <input
                      ref="coverimage"
                      type="file"
                      accept="image/*"
                      @change="CoverImage()"
                      class="d-none"
                    />
                    <v-btn @click="$refs.coverimage.click()">
                      <v-icon small class="mr-2">mdi-image</v-icon>
                      เลือกรูปภาพ
                    </v-btn>
                  </v-card>
                  <v-card v-show="surveyform.surveyCoverPic" flat>
                    <v-card>
                      <v-card-title class="pa-1">
                        <v-spacer></v-spacer>
                        <v-btn
                          icon
                          color="#DE4F3B"
                          @click="surveyform.surveyCoverPic = ''"
                          ><v-icon>clear</v-icon></v-btn
                        >
                      </v-card-title>
                      <v-card-text class="d-flex justify-center">
                        <img :src="surveyform.surveyCoverPic" width="100" />
                      </v-card-text>
                      <v-card-text>
                        <v-btn
                          color="primary"
                          outlined
                          block
                          @click="$refs.coverimage.click()"
                          >เปลี่ยนรูป</v-btn
                        >
                      </v-card-text>
                    </v-card>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#033666"
              :disabled="ButtonLoading"
              outlined
              @click="dialog = false"
            >
              ยกเลิก
            </v-btn>
            <v-btn
              color="#033666"
              :loading="ButtonLoading"
              dark
              @click="AddSurvey"
            >
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  props: ["trial"],
  data: () => ({
    dialog: false,
    surveyform: {
      surveyName: "",
      surveyDetail: "",
      surveyCoverPic: "",
    },
    cover: false,
    cover_image: "",
  }),
  computed: {
    ButtonLoading() {
      return this.$store.state.button_loading;
    },
    SPermission() {
      return this.$store.state.user_permission;
    },
  },
  methods: {
    CoverImage() {
      for (const key in this.$refs.coverimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.coverimage.files, key)) {
          const element = this.$refs.coverimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-cover/question/`
            );
            formData.append("fileName", `${Date.now()}-cover-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              vm.surveyform.surveyCoverPic = req.data;
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.coverimage.type = "text";
              this.$refs.coverimage.type = "file";
            });
          }
        }
      }
      this.$refs.coverimage.type = "text";
      this.$refs.coverimage.type = "file";
    },
    AddSurvey() {
      if (this.$refs.form.validate()) {
        this.$store.commit("ToggleButtonLoading");
        this.$store
          .dispatch("AddSurvey", {
            surveyID: this.$store.getters.UUID(),
            surveyName: this.surveyform.surveyName,
            surveyDetail: this.surveyform.surveyDetail,
            surveyCoverPic: this.surveyform.surveyCoverPic,
            surveyStatus: false,
            enableSchedule: false,
            surveyDatetimeStart: `${new Date()
              .toISOString()
              .substring(0, 10)}T08:00`,
            surveyDatetimeEnd: `${new Date(
              new Date().setDate(new Date().getDate() + 31)
            )
              .toISOString()
              .substring(0, 10)}T08:00`,
            enableAuth: false,
            enableOneTime: false,
            editable: true,
          })
          .then(() => {
            this.dialog = false;
            Swal.fire({
              icon: "success",
              text: "เพิ่มเรียบร้อยแล้ว",
              title: "",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.$store.commit("ToggleButtonLoading");
              this.$store.dispatch("getSurvey");
              this.$refs.form.reset();
              this.$refs.form.resetValidation();
            });
          });
        // .catch((resp) => {
        //   let text = `คุณไม่มีสิทธิ์เพิ่ม survey ได้<br>กรุณาติดต่อทีมงานเพื่อให้สามารถใช้งานได้ที่<br><a style="color: #0093cc;"
        //             href='tel:0935781416'
        //             >093-5781416</a
        //           >, <a style="color: #0093cc;"
        //           href='tel:0655214474'
        //           >065-5214474</a
        //         >`;
        //   Swal.fire({
        //     icon:
        //       resp.data.message === "Dont have package" ? "warning" : "error",
        //     html:
        //       resp.data.message === "Dont have package"
        //         ? this.trial
        //           ? "กรุณาทดลองเริ่มการใช้งานก่อน"
        //           : text
        //         : "ไม่สามารถเพิ่มได้",
        //     title: "",
        //   }).then(() => {
        //     this.$store.commit("ToggleButtonLoading");
        //   });
        // });
      }
    },
    validclose() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
  },
};
</script>
